module.exports = __webpack_public_path__ + "static/media/wordpress.56be517f.svg";